import React from 'react';

/**
 * SectionShell — consistent header + content wrapper for every Plan section.
 * Keeps all seven sections visually aligned (icon, title, subtitle, badge).
 */
export default function SectionShell({
  icon: Icon, title, subtitle, badge, color = '#67e8f9', testId, children,
}) {
  return (
    <section
      className="jbv2-section"
      style={{ '--jb-c': color }}
      data-testid={testId}
    >
      <div className="jbv2-section-head">
        {Icon && (
          <div className="jbv2-section-head-icon">
            <Icon size={18} strokeWidth={2.2} />
          </div>
        )}
        <div className="jbv2-section-head-text">
          <h3 className="jbv2-section-title">{title}</h3>
          {subtitle && <span className="jbv2-section-sub">{subtitle}</span>}
        </div>
        {badge && <span className="jbv2-section-badge">{badge}</span>}
      </div>
      {children}
    </section>
  );
}
